import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCircleHalfFill: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCircleHalfFill"><Path fillRule="evenodd" clipRule="evenodd" d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3V21ZM22 12C22 17.5228 17.5228 22 12 22C11.8236 22 11.6483 21.9954 11.4741 21.9864C6.19549 21.7127 2 17.3465 2 12C2 6.65354 6.19549 2.28732 11.4741 2.0136C11.6483 2.00457 11.8236 2 12 2C17.5228 2 22 6.47715 22 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCircleHalfFill;
